import { useContext } from 'react';
import Maybe from 'true-myth/maybe';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { formatDateByLocale } from '../../../../date/date-formatter';
import { TableCellLinkWrapper } from '../common/TableCellLinkWrapper';
import { SkillCell } from '../skills/SkillCell';
import { TableCellWrapper } from '../skills/TableCellWrapper';

import type { GlobalSearchJob } from '../../../../data-contract/global-search';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

// eslint-disable-next-line functional/prefer-readonly-type
export const useJobOpeningsColumns = (prioritySkillIds?: readonly string[]): GridColDef[] => {
    const {
        applicationState: { languageKey },
        translate,
    } = useContext(ApplicationContext);

    return [
        {
            disableColumnMenu: true,
            field: 'title',
            flex: 0.5,
            headerName: translate('pages.global-search.headlines.job-postings'),
            renderCell: ({ row }: GridRenderCellParams<GlobalSearchJob>) => (
                <TableCellLinkWrapper to={`/jobs/${row?.id}`}>{row?.title}</TableCellLinkWrapper>
            ),
            resizable: false,
            sortable: true,
        },
        {
            disableColumnMenu: true,
            field: 'publishedAt',
            flex: 0.5,
            headerName: translate('pages.global-search.headlines.published'),
            renderCell: ({ row }: GridRenderCellParams<GlobalSearchJob>) => {
                const date = formatDateByLocale({
                    dateStringToFormat: Maybe.of(row?.publishedAt),
                    locale: languageKey,
                }).unwrapOr(null);

                return <TableCellWrapper>{date}</TableCellWrapper>;
            },
            resizable: false,
            sortable: true,
        },
        {
            disableColumnMenu: true,
            field: 'skills',
            flex: 1,
            headerName: translate('pages.global-search.headlines.required-skills'),
            renderCell: (params: GridRenderCellParams<GlobalSearchJob>) => (
                <SkillCell
                    defaultVisibleSkillsCount={1}
                    prioritySkillIds={prioritySkillIds}
                    skills={params.row.skills}
                />
            ),
            resizable: false,
            sortable: false,
        },
    ];
};
